import styleguide from '@hw-ui/styleguide/routes'
import components from '@hw-ui/ui/routes'
import unused from '@hw-ui/unused/routes'

const app = [
  {
    path: '/',
    name: 'hw-ui',
    component: () => import('./App.vue'),
    meta: {
      resource: 'Auth',
    },
  }
]
export default [
  ...app,
  ...styleguide,
  ...components,
  ...unused
]